<div class="edit-study-main-container">
    <div class="content-container" *ngIf="roleId===adminRole || roleId===championRole || roleId === clientAdmin">

        <form [formGroup]="targetForm">

            <!-- Start of Create StudydHeader --!-------------------------------------------------->
            <div id="createStudy" *ngIf="isCreateStudy">
                <div class="home-top-sec">
                    <div class="divstart">Create a New Study</div>

                    <div class="study-create-buttons-section">
                        <!-- <span class="study-create-fav-text" (click)="setStudyAsFavorite()">
                        <i *ngIf="!isSetToFavorite" class="fa-regular fa-star study-create-fav-icon"></i>
                        <i *ngIf="isSetToFavorite" class="fa-solid fa-star study-create-fav-icon"></i>
                        Favorite
                    </span> -->
                        <div class="divend">
                            <button type='button' (click)="onCancel()" class="transparent-btn">Cancel</button>
                        </div>
                        <div>
                            <button type='button' class="btn btn-success" *ngIf="!readyToSubmit"
                                [disabled]="(!targetForm.valid ||  engagementNameError || engagementManagerSelectedId === 0 || engagementPartnerSelectedId === 0 || studyFlagOptionId === 0) || isTaxPeriodReady || isDGclient"
                                (click)="onContinue()">
                                Continue</button>
                        </div>
                        <div>
                            <button type='button' class="btn btn-success" *ngIf="readyToSubmit" (click)="createStudy()"
                                data-custom-parentid="Create Study" data-custom-id="Create Study"
                                [disabled]="(!targetForm.valid || engagementNameError || engagementManagerSelectedId === 0 || engagementPartnerSelectedId === 0 || studyFlagOptionId === 0 || isTaxPeriodReady) && !isDisabled || isDGclient">
                                Create Study
                            </button>
                        </div>
                    </div>
                </div>
                <hr class="horizontal-line">
                <div class="create-steps">
                    <div class="rde-row">

                        <ul class="breadcrumb">
                            <li [ngClass]="{ 'selectedBreadcrumbs' : selectedTab.selectStudyDetails  }" class="steps"
                                [attr.disabled]="!selectedTab.selectStudyDetails ? true : fasle">
                                <a (click)="navigateToSurveyScreen('selectStudyDetails')">
                                    <span class="numbers">1</span>Study Details
                                </a>
                            </li>
                            <li [ngClass]="{ 'selectedBreadcrumbs' : selectedTab.selectTaxYear  }" class="steps"
                                [attr.disabled]="!selectedTab.selectTaxYear ? true : fasle">
                                <a (click)="navigateToSurveyScreen('selectTaxYear')">
                                    <span class="numbers">2</span>Tax Periods
                                </a>
                            </li>
                            <li [ngClass]="{ 'selectedBreadcrumbs' : selectedTab.selectStudyConfiguration  }"
                                class="steps" [attr.disabled]="!selectedTab.selectStudyConfiguration ? true : fasle">
                                <a (click)="navigateToSurveyScreen('selectStudyConfiguration')">
                                    <span class="numbers">3</span>Study Configuration
                                </a>
                            </li>
                            <li [ngClass]="{ 'selectedBreadcrumbs' : selectedTab.selectAccessPermission  }"
                                class="steps" [attr.disabled]="!selectedTab.selectAccessPermission ? true : fasle">
                                <a (click)="navigateToSurveyScreen('selectAccessPermission')">
                                    <span class="numbers">4</span>Access & Permissions
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- End of Create StudydHeader --!-------------------------------------------------->
            <!-- Start of Edit StudydHeader --!-------------------------------------------------->
            <div id="editStudy" *ngIf="!isCreateStudy">
                <div class="home-top-sec">
                    <div class="divstart">Edit Study</div>
                    <div class="study-create-buttons-section">
                        <!-- <span class="study-create-fav-text" (click)="setStudyAsFavorite()">
                        <i *ngIf="!isSetToFavorite" class="fa-regular fa-star study-create-fav-icon"></i>
                        <i *ngIf="isSetToFavorite" class="fa-solid fa-star study-create-fav-icon"></i>
                        Favorite
                    </span> -->
                        <div class="divend">
                            <span class="padding-right"><toggle-switch (toggleState)="masterCheckboxaction($event)"
                                    [switchState]="check">
                                </toggle-switch>
                                Archive this study</span>
                            <button type='button' (click)="onCancelEdit()" class="transparent-btn">
                                Cancel</button>
                        </div>
                        <div>
                            <button type='button' class="btn btn-success" data-custom-parentid="Edit Study"
                                data-custom-id="Edit Study"
                                [disabled]="(!targetForm.valid && !isClientAdmin) || isDisabled || engagementManagerSelectedId === 0 || engagementPartnerSelectedId === 0 || studyFlagOptionId === 0 || engagementNameError"
                                (click)="updateEngagement()">
                                Update
                            </button>
                        </div>
                    </div>
                </div>

                <div class="create-steps">
                    <div style="width: 100%;">
                        <section class="engagement-preparation-navigation">
                            <ul style="margin-bottom: 0px !important">
                                <li (click)="navigateToSurveyScreen('selectStudyDetails')" routerLinkActive="active"
                                    *ngIf="!selectedTab.selectStudyDetails">
                                    <h5>Study Details</h5>
                                </li>
                                <li class="selected" *ngIf="selectedTab.selectStudyDetails">
                                    <h5>Study Details</h5>
                                </li>
                                <li (click)="navigateToSurveyScreen('selectTaxYear')" routerLinkActive="active"
                                    [ngClass]="{'selected' : selectedTab.selectTaxYear}">
                                    <h5>Tax Periods</h5>
                                </li>
                                <li (click)="navigateToSurveyScreen('selectClientUsers')" routerLinkActive="active"
                                    [ngClass]="{'selected' : selectedTab.selectClientUsers}">
                                    <h5>Client SMEs</h5>
                                </li>
                                <li (click)="navigateToSurveyScreen('selectStudyConfiguration')"
                                    routerLinkActive="active"
                                    [ngClass]="{'selected' : selectedTab.selectStudyConfiguration}">
                                    <h5>Study Configuration</h5>
                                </li>
                                <li (click)="navigateToSurveyScreen('selectAccessPermission')" routerLinkActive="active"
                                    [ngClass]="{'selected' : selectedTab.selectAccessPermission}">
                                    <h5>Access & Permissions</h5>
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
                <hr class="horizontal-line">
            </div>
            <!-- End of Edit StudydHeader --!-------------------------------------------------->
            <div>
                <!-- existing componenet --!--->
                <div class="study-detail-block">

                    <div class="input-field-block">
                        <!---Start of study Details tab------------------------------------------------------->
                        <div class="rde-row" id="studyDetails" *ngIf="selectedTab.selectStudyDetails">
                            <div class="col-6 study-head-dir">
                                <div class="rde-row  ignore-col head-row" *ngIf="isCreateStudy">
                                    <span>
                                        <h5 class="study-details">Study Details</h5>
                                    </span>
                                </div>
                                <div class="rde-row head-row-edit" *ngIf="!isCreateStudy">
                                    <span>
                                        <h5>{{clientName}}</h5>
                                    </span>
                                    <div class="padding-top">
                                        <h5>{{engagementManagerToDisplay}},&nbsp;Engagement Manager&nbsp; |&nbsp;
                                            {{engagementPartnerToDisplay}},&nbsp;Engagement Partner</h5>
                                    </div>
                                </div>


                            </div>
                            <div class="head-row" *ngIf="!isDGclient">
                                <div class="rde-row ignore-col">
                                    <div class="team-mem-row ">
                                        <span>
                                            <h5 class="study-details">Study Type : </h5>
                                        </span>

                                        <div class="study-flag-radiobuttons">
                                            <div *ngFor="let flagOption of engagementFlagOptions.options">
                                                <label class="chkbox-container">{{flagOption.value}}
                                                    <input type="radio" name="selectFlag"
                                                        [checked]="studyFlagOptionId===flagOption.id"
                                                        (change)="flagOptionClick(flagOption.id)"
                                                        [disabled]="isClientAdmin">
                                                    <span class="chk-checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="head-row-pink-banner" *ngIf="isDGclient">
                                <div class="circle-icon">
                                    <i class="fa-solid fa-circle-exclamation exclamation-icon"></i>
                                </div>
                                <div class="pink-message">
                                    <div class="message-text">
                                        Unable to create a study for this client in RCN since the client is already set
                                        up
                                        in Digital Gateway.<br>
                                        Please access the client in Digital Gateway.
                                    </div>
                                    <div class="messsage-button">
                                        <span class="dg-link pink2" (click)="goToDgClick()">Go to Digital Gateway</span>
                                    </div>
                                </div>
                            </div>


                            <div class="col-6">
                                <div class="rde-row ignore-col">
                                    <div class="col-6 no-padding width-40" *ngIf="isCreateStudy">
                                        <label for="hcne-clients" class="width-100">
                                            <i class="far fa-asterisk star-style"></i> Client Name
                                            <span
                                                *ngIf="f.clientName.errors && (f.clientName.touched || f.clientName.dirty) && !isClientSelected">
                                                <span class="required-error"
                                                    *ngIf="f.clientName.errors.required">(required)</span>
                                            </span>
                                            <ng-container *ngIf="!isClientMode">
                                                <div class="input-elm">
                                                    <input id="client-name"
                                                        class="black-input opposite-colors clients-autocomplete"
                                                        [ngClass]="{'ng-invalid' :  (f.clientName.touched || f.clientName.dirty)}"
                                                        placeholder="Search client name" type="text"
                                                        no-special-chars="#!$%^<>+=" required
                                                        (keyup)="onClientNameChanged($event.target.value)"
                                                        [kpmgUiTypeahead]="searchExistingClients" [resultTemplate]="ct"
                                                        [editable]="true" [inputFormatter]="clientFormatter"
                                                        (blur)="showClientUsers(f.clientName.value); checkIfDGClient(f.clientName.value)"
                                                        #custSearch (selectItem)="onClientSelected($event)"
                                                        formControlName="clientName">
                                                    <span class="search-icon"><i class="fas fa-search"></i></span>
                                                </div>
                                                <ng-template #ct let-c="result" let-t="term">
                                                    <kpmg-ui-highlight class="create-engagement-typeahead"
                                                        [result]="c.clientName" [term]="t">
                                                    </kpmg-ui-highlight>&nbsp;
                                                </ng-template>
                                            </ng-container>
                                            <ng-container *ngIf="isClientMode">
                                                <input id="client-name"
                                                    class="black-input opposite-colors clients-autocomplete"
                                                    [ngClass]="{'ng-invalid' :  (f.clientName.touched || f.clientName.dirty)}"
                                                    required (keyup)="onClientNameChanged($event.target.value)"
                                                    placeholder="Client Name" type="text" no-special-chars="#!$%^<>+="
                                                    [(ngModel)]="engagementClient"
                                                    (blur)="showClientUsers(f.clientName.value)"
                                                    formControlName="clientName">
                                            </ng-container>
                                        </label>
                                        <div class="form-error-sign"
                                            *ngIf="targetForm.controls.clientName.errors?.maxlength">
                                            <p>Client name exceeds character limit.</p>
                                        </div>
                                    </div>
                                    <div class="col-6 no-padding width-40" *ngIf="!isCreateStudy">
                                        <span
                                            *ngIf="f.clientName.errors && (f.clientName.touched || f.clientName.dirty) && !isClientSelected">
                                            <span class="required-error"
                                                *ngIf="f.clientName.errors.required">(required)</span>
                                        </span>
                                        <div class="input-elm">
                                            <label for="hcne-clients" class="width-100">
                                                <span>Client Name
                                                    <input id="client-name"
                                                        class="black-input opposite-colors clients-autocomplete"
                                                        placeholder="Client Name" type="text"
                                                        formControlName="clientName" no-special-chars="#!$%^<>+='"
                                                        (blur)="trimSpecialChar('clientName');" readonly="readonly" />
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-6 hcne-kpmgClients input-with-icon no-padding width-50">
                                        <div>
                                            <label for="hcne-engagementName" class="width-100">
                                                <i class="far fa-asterisk star-style"></i> Study Name
                                                <span
                                                    *ngIf="f.engagementName.errors && (f.engagementName.touched || f.engagementName.dirty)">
                                                    <span class="required-error"
                                                        *ngIf="f.engagementName.errors.required">(required)</span>
                                                </span>
                                                <input id="engagement-name" class="black-input opposite-colors"
                                                    placeholder="Required" type="text" no-special-chars="!$%^<>+='"
                                                    (blur)="trimSpecialChar('engagementName');"
                                                    formControlName="engagementName" required [readonly]="isClientAdmin"
                                                    (input)="onEngagementNameChanged($event.target.value)" />
                                            </label>
                                        </div>

                                        <div class="form-error-sign" *ngIf="engagementNameError">
                                            <p>Study name is already in use.</p>
                                        </div>
                                        <div class="form-error-sign"
                                            *ngIf="targetForm.controls.engagementName.errors?.maxlength">
                                            <p>Study name exceeds character limit.</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- Start Engagement Number Row --!-->
                                <div class="rde-row ignore-col">
                                    <div class="col-6 width-40">
                                        <div class="hcne-engagementNumber mt-2 no-padding">
                                            <label for="hcne-engagementNumber" class="width-100">
                                                <i class="far fa-asterisk star-style"></i> Engagement Number
                                                <span
                                                    *ngIf="f.engagementNumber.errors && (f.engagementNumber.touched || f.engagementNumber.dirty)">
                                                    <span class="required-error"
                                                        *ngIf="f.engagementNumber.errors.required">(required)</span>
                                                </span>
                                                <input id="eng-number" class="black-input opposite-colors"
                                                    placeholder="Required" type="text"
                                                    (blur)="trimSpecialChar('engagementNumber');"
                                                    formControlName="engagementNumber" required
                                                    [readonly]="isClientAdmin"
                                                    (input)="onEngagementNumberChanged($event.target.value)" />
                                            </label>
                                        </div>
                                        <div *ngIf="studyFlagOptionId === engagementFlag.Live">
                                            <p class="section-info">Engagement number must be a 10 digit numeric value.
                                            </p>
                                        </div>
                                        <div *ngIf="studyFlagOptionId === engagementFlag.Demo">
                                            <p class="section-info">Engagement number must be an alphanumeric value.</p>
                                        </div>
                                        <div class="form-error-sign"
                                            *ngIf="targetForm.controls.engagementNumber.errors && !f.engagementNumber.errors.required">
                                            <p>Engagement Number is not valid.</p>
                                        </div>
                                    </div>


                                </div>
                                <!-- End Engagement Number Row --!-->
                                <div>
                                    <div class="rde-row ignore-col" *ngIf="isCreateStudy">
                                        <div class="no-padding width-40">
                                            <div class="no-padding hcne-engagementName mt-2">
                                                <label for="" class="width-100">
                                                    <i class="far fa-asterisk star-style"></i> Engagement Manager
                                                    <div class="input-elm">
                                                        <input
                                                            class="black-input opposite-colors kpmg-user-autocomplete"
                                                            placeholder="Enter a KPMG User Name" type="text"
                                                            no-special-chars="#!$%^<>+="
                                                            [kpmgUiTypeahead]="searchEngagementManagerStream"
                                                            [resultTemplate]="rt" [editable]="false"
                                                            [inputFormatter]="kpmgUserFormatter"
                                                            (keydown)="searchKPMG(true)"
                                                            (selectItem)="onEngagementManagerSelect($event)">
                                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                                    </div>
                                                    <ng-template #rt let-r="result" let-t="term">
                                                        <kpmg-ui-highlight *ngIf="engagementManagerKPMGUser"
                                                            class="create-engagement-typeahead"
                                                            [innerHtml]='finalEngagementManagerstrKPMG' [term]="t">
                                                        </kpmg-ui-highlight>
                                                        <kpmg-ui-highlight *ngIf="!engagementManagerKPMGUser"
                                                            [title]="r.userName" class="create-engagement-typeahead"
                                                            [result]="r.displayName" [term]="t">
                                                        </kpmg-ui-highlight>&nbsp;

                                                    </ng-template>

                                                </label>
                                            </div>

                                            <div *ngIf="engagementManagerSelected && engagementManagerSelected.length > 0"
                                                class="mt-2">
                                                <ngx-datatable
                                                    class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                                    [rows]="engagementManagerSelected" [headerHeight]="0"
                                                    [rowHeight]="35"
                                                    [ngStyle]="{'height': engagementManagerSelected.length * 45 +'px' }">
                                                    <ngx-datatable-column [width]="width-100">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                            <button class="link-button"
                                                                (click)="removeEngagementManagerSelected(row)">
                                                                <i class="fas fa-times cross-i-style"></i>
                                                            </button>
                                                        </ng-template>
                                                    </ngx-datatable-column>
                                                    <ngx-datatable-column prop="name">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                            {{row.displayName}}
                                                        </ng-template>
                                                    </ngx-datatable-column>
                                                </ngx-datatable>
                                            </div>
                                            <div *ngIf="noResultflag">
                                                <div>
                                                    user is not found.
                                                </div>
                                                <div class="add-user-link">Add this user</div>
                                            </div>
                                        </div>
                                        <!--Engagement Partner-->
                                        <div class="no-padding width-50">
                                            <div class="hcne-engagementNumber mt-2 no-padding">
                                                <label for="" class="width-100">
                                                    <i class="far fa-asterisk star-style"></i> Engagement Partner

                                                    <div class="input-elm">
                                                        <input
                                                            class="black-input opposite-colors kpmg-user-autocomplete"
                                                            placeholder="Enter a KPMG User Name" type="text"
                                                            no-special-chars="#!$%^<>+="
                                                            [kpmgUiTypeahead]="searchEngagementPartnerStream"
                                                            [resultTemplate]="eprt" [editable]="false"
                                                            [inputFormatter]="kpmgUserFormatter"
                                                            (keydown)="searchKPMG(true)"
                                                            (selectItem)="onEngagementPartnerSelect($event)">
                                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                                    </div>
                                                    <ng-template #eprt let-r="result" let-t="term">
                                                        <kpmg-ui-highlight *ngIf="engagementPartnerKPMGUser"
                                                            class="create-engagement-typeahead" [title]="r.userName"
                                                            [innerHtml]='finalEngagementPartnerstrKPMG' [term]="t">
                                                        </kpmg-ui-highlight>
                                                        <kpmg-ui-highlight *ngIf="!engagementPartnerKPMGUser"
                                                            [title]="r.userName" class="create-engagement-typeahead"
                                                            [result]="r.displayName" [term]="t">
                                                        </kpmg-ui-highlight>&nbsp;

                                                    </ng-template>

                                                </label>
                                            </div>
                                            <div *ngIf="engagementPartnerSelected && engagementPartnerSelected.length > 0"
                                                class="mt-2">
                                                <ngx-datatable
                                                    class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                                    [rows]="engagementPartnerSelected" [headerHeight]="0"
                                                    [rowHeight]="35"
                                                    [ngStyle]="{'height': engagementPartnerSelected.length * 45 +'px' }">
                                                    <ngx-datatable-column [width]="30">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                            <button class="link-button"
                                                                (click)="removeEngagementPartnerSelected(row)">
                                                                <i class="fas fa-times cross-i-style"></i>
                                                            </button>
                                                        </ng-template>
                                                    </ngx-datatable-column>
                                                    <ngx-datatable-column prop="name" [width]="250">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                            {{row.displayName}}
                                                        </ng-template>
                                                    </ngx-datatable-column>
                                                </ngx-datatable>
                                            </div>
                                            <div *ngIf="noResultflag">
                                                <div>
                                                    User could not be found.
                                                </div>
                                                <div class="add-user-link">Add this user</div>
                                            </div>
                                        </div>
                                        <!--End of Engagement Partner-->
                                    </div>
                                </div>
                                <div class="rde-row ignore-col">

                                    <!-- start  Prior Year and Estimated Qre --!-->
                                    <div class="col-6 width-40">
                                        <div class="rde-row ignore-col">
                                            <div class="col-6 no-padding width-40">
                                                <label for="hcne-startDate">
                                                    Prior Year QRE
                                                    <div>
                                                        <input class="black-input opposite-colors"
                                                            (keyup)="_keyUp($event)" formControlName="priorYearQre"
                                                            type="number" max=99999999999999.9888
                                                            [readonly]="isClientAdmin">
                                                    </div>
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- Prior Year and Estimated Qre--!-->
                                </div>
                            </div>


                        </div>
                        <!---End of study Detailstab------------------------------------------------------->
                        <!---Start of Client SMEs-----!--->
                        <div class="rde-row" style="padding-top: 10px;" id="studyConfiguration"
                            *ngIf="selectedTab.selectClientUsers">

                            <manage-client-users [clientId]="clientId" [clientName]="clientName"
                                [clientUsers]="clientUsersSelected" [enableBulkUser]="enableBulkUser"
                                [canAddClientUsers]="canAddClientUsers"
                                (updateClientManager)="updateClientManager($event)"
                                (updateClientAdmin)="updateClientAdmin($event)"
                                (removeClientAdmin)="removeClientAdmin($event)">
                            </manage-client-users>

                        </div>
                        <!---End of Client SMEs tab-----!--->
                        <!---Start of Study Configuration tab------------------------------------------------------->
                        <div class="rde-row" id="studyConfiguration" *ngIf="selectedTab.selectStudyConfiguration">
                            <div class="col-6 study-head-dir">
                                <div class="rde-row  ignore-col head-row">
                                    <span>
                                        <h5 class="study-details">Study Configuration</h5>
                                    </span>
                                </div>

                            </div>
                            <div class="col-6 no-padding">
                                <div class="rde-row  ignore-col">


                                    <div class="col-6  right-padding width-50 hcne-engagementName width-30">
                                        <label for="hcne-engagementName" class="width-100">
                                            <i class="far fa-asterisk star-style"></i> Email Reminders 
                                            <span tooltip="Counts based off calendar days, emails are only sent out on weekdays"
                                                [options]="toolTipOptions">
                                                <i class="fas fa-info-circle info-pad"></i>
                                            </span>
                                            <span
                                                *ngIf="f.engagementName.errors && (f.engagementName.touched || f.engagementName.dirty)">
                                                <span class="required-error"
                                                    *ngIf="f.engagementName.errors.required">(required)</span>
                                            </span>
                                            <div class="input-elm">
                                                <custom-dropdown [selectText]="emailReminderText"
                                                    [options]="emailReminderOptions"
                                                    (optionSelectedEvent)="onEmailFrequencySelected($event)">
                                                </custom-dropdown>
                                                <div class="form-warning-sign"
                                                    *ngIf="f.engagementEmailFrequency.value===0">
                                                    <p class="mt-0">* Email reminder is disabled</p>
                                                </div>
                                                <div class="form-error-sign" *ngIf="!f.engagementEmailFrequency.valid">
                                                    <p class="mt-0">Email Reminder Frequency should be between. 0 and
                                                        10.
                                                    </p>
                                                </div>
                                            </div>
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!---End of Study Configuration tab------------------------------------------------------->

                        <!---Start of Access & Permission------------------------------------------------------->
                        <div id="accessandPermission" *ngIf="selectedTab.selectAccessPermission">

                            <div class="padding-bottom">
                                <div class="rde-row add-user-sec">
                                    <div class="col-6">
                                        <div class="add-user-block" *ngIf="!isClientAdmin">
                                            <label for="hcne-clients">
                                                Add KPMG Users
                                            </label>
                                            <div class="hcne-kpmg-users">
                                                <div class="hcne-kpmgUsers input-with-icon mt-2">
                                                    <div class="input-elm">
                                                        <input
                                                            class="black-input opposite-colors kpmg-user-autocomplete"
                                                            placeholder="Enter a KPMG User Name" type="text"
                                                            no-special-chars="#!$%^<>+="
                                                            [kpmgUiTypeahead]="searchUserStream"
                                                            [resultTemplate]="addkpmgrt" [editable]="false"
                                                            [inputFormatter]="kpmgUserFormatter"
                                                            (keydown)="searchKPMG(true)"
                                                            (selectItem)="onKPMGUserSelect($event)">
                                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                                    </div>
                                                    <ng-template #addkpmgrt let-r="result" let-t="term">
                                                        <kpmg-ui-highlight *ngIf="engagementAddKPMGUser"
                                                            class="create-engagement-typeahead"
                                                            [innerHtml]='finalAddKPMGUserstrKPMG' [term]="t">
                                                        </kpmg-ui-highlight>
                                                        <kpmg-ui-highlight *ngIf="!engagementAddKPMGUser"
                                                            [title]="r.userName" class="create-engagement-typeahead"
                                                            [result]="r.displayName" [term]="t">
                                                        </kpmg-ui-highlight>&nbsp;

                                                    </ng-template>
                                                    <div class="trouble-user">
                                                        <span *ngIf="roleId !== roleEnum.clientAdmin"
                                                            tooltip={{guidance_kpmg_user}} offset="0" zIndex="30000"
                                                            [options]="toolTipOptions">
                                                            <i class="fas fa-info-circle info-pad"></i>Trouble looking
                                                            up a
                                                            user?
                                                        </span>
                                                    </div>
                                                </div>

                                                <div *ngIf="kpmgUsersSelected.length > 0" class="mt-2">
                                                    <ngx-datatable
                                                        class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                                        [rows]="kpmgUsersSelected" [headerHeight]="0" [rowHeight]="35"
                                                        [ngStyle]="{'height': kpmgUsersSelected.length * 45 +'px' }">
                                                        <ngx-datatable-column [width]="30">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <button class="link-button"
                                                                    (click)="removeKPMGUser(row)" tabindex="1"
                                                                    [attr.disabled]="check? true : null"
                                                                    *ngIf="user.email.trim()!==row.email.trim()">
                                                                    <i class="fas fa-times cross-i-style"></i>
                                                                </button>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column prop="name" [width]="250">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                {{row.displayName}}
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                    </ngx-datatable>
                                                </div>
                                                <div *ngIf="noResultflag">
                                                    <div>
                                                        user is not found.
                                                    </div>
                                                    <div class="add-user-link">Add this user</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--Add Client SMEs-->
                                    <!--    <div class="col-6">
                                    <div class="add-user-block">
                                        <label for="hcne-clients">Add Client Managers</label>
                                        <div class="hcne-kpmg-clientusers">
                                            <div class="hcne-kpmgUsers input-with-icon mt-2">
                                                <div class="input-elm">
                                                    <input class="black-input opposite-colors kpmg-user-autocomplete"
                                                        [ngClass]="{disabledText: !clientUsers}"
                                                        placeholder="Enter a Client SME Name" type="text"
                                                        no-special-chars="#!$%^<>+="
                                                        [kpmgUiTypeahead]="searchUserStream" [resultTemplate]="rt"
                                                        [editable]="false" [inputFormatter]="clientUserFormatter"
                                                        (keydown)="searchKPMG(false)"
                                                        (selectItem)="onClientUserSelect($event)"
                                                        [disabled]="!clientUsers">
                                                    <span class="search-icon"><i class="fas fa-search"></i></span>
                                                </div>
                                                <ng-template #rt let-r="result" let-t="term">
                                                    <kpmg-ui-highlight [title]="r.userName"
                                                        class="create-engagement-typeahead" [result]="r.displayName"
                                                        [term]="t">
                                                    </kpmg-ui-highlight>&nbsp;
                                                </ng-template>
                                            </div>

                                            <div *ngIf="clientUsersSelected.length > 0" class="mt-2">
                                                <ngx-datatable
                                                    class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                                    [rows]="clientUsersSelected" [headerHeight]="0" [rowHeight]="35"
                                                    [ngStyle]="{'height': clientUsersSelected.length * 45 +'px' }">
                                                    <ngx-datatable-column [width]="30">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                            <button class="link-button" (click)="removeClientUser(row)">
                                                                <i class="fas fa-times cross-i-style"></i>
                                                            </button>
                                                        </ng-template>
                                                    </ngx-datatable-column>
                                                    <ngx-datatable-column prop="name" [width]="250">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                            {{row.displayName}}
                                                        </ng-template>
                                                    </ngx-datatable-column>
                                                </ngx-datatable>
                                            </div>
                                        </div>
                                    </div>
                                </div>-->
                                    <!--End Client SMEs-->
                                </div>
                            </div>
                            <!--Start of div-->
                            <div>
                                <div class="inline-div-first" id="studyDetails">
                                    <div class="col-6 study-head-dir">
                                        <div class="rde-row  ignore-col head-row">
                                            <span>
                                                <h5 class="study-details">Grant Permissions</h5>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-6 ">
                                        <div class="rde-row  ignore-col head-row">
                                            <span>
                                                <h5 class="permission-header-text">Allow client managers to:</h5>
                                            </span>
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'clientmanagerqreinsight')"
                                                [switchState]="studyConfigurationSettings.checkclientmanagerqreinsight">
                                            </toggle-switch>
                                            See QREs on landing page and insights page
                                        </div>
                                    </div>
                                    <div class="col-6 ">
                                        <div class="rde-row  ignore-col head-row">
                                            <span>
                                                <h5 class="permission-header-text">In Time Surveys, allow SMEs to:</h5>
                                            </span>
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveyupload')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveyupload">
                                            </toggle-switch>
                                            Upload documents
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveysubmitconditionwithdocument')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveysubmitconditionwithdoc">
                                            </toggle-switch>
                                            Submit only after one document is uploaded
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveyAddEmployee')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveyAddEmployee">
                                            </toggle-switch>
                                            Add/remove new Employees
                                        </div>

                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveyaddproject')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveyaddproject">
                                            </toggle-switch>
                                            Add new Business Components
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveyaddactivities')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveyaddactivities">
                                            </toggle-switch>
                                            Add new activities
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveyaddnqa')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveyaddnqa">
                                            </toggle-switch>
                                            Add new non-qualified activities
                                        </div>
                                        <div class="col-6">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveyaddnwt')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveyaddnwt">
                                            </toggle-switch>
                                            Add new non-working time
                                        </div>
                                        <div class="col-6">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smetimesurveysubmitcondition')"
                                                [switchState]="studyConfigurationSettings.checksmetimesurveysubmitcondition">
                                            </toggle-switch>
                                            Submit only if all employee allocated at 100%
                                        </div>
                                        <div class="col-6">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'checksmeatleastonecheckboxselectedsubmitcondition')"
                                                [switchState]="studyConfigurationSettings.checksmeatleastonecheckboxselectedsubmitcondition">
                                            </toggle-switch>
                                            Submit only if at least one checkbox is selected for employees with
                                            qualified
                                            time
                                        </div>
                                    </div>
                                    <div class="col-6 ">
                                        <div class="rde-row  ignore-col head-row">
                                            <span>
                                                <h5 class="permission-header-text">In Qualitative Surveys, allow SMEs
                                                    to:
                                                </h5>
                                            </span>
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smeprojectsurveysubmitcondition')"
                                                [switchState]="studyConfigurationSettings.checksmeprojectsurveysubmitcondition">
                                            </toggle-switch>
                                            Submit only after one document is uploaded
                                        </div>
                                    </div>
                                    <div class="col-6 ">
                                        <div class="rde-row  ignore-col head-row">
                                            <span>
                                                <h5 class="permission-header-text">In Expense Surveys, allow SMEs to:
                                                </h5>
                                            </span>
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smeuploaddocumentexpensesurvey')"
                                                [switchState]="studyConfigurationSettings.checksmeuploaddocumentexpensesurvey">
                                            </toggle-switch>
                                            Upload documents
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smeexpensesurveysubmitconditionwithdocument')"
                                                [switchState]="studyConfigurationSettings.checksmeexpensesurveysubmitconditionwithdoc">
                                            </toggle-switch>
                                            Submit only after one document is uploaded
                                        </div>
                                        <div class="col-6 ">
                                            <toggle-switch
                                                (toggleState)="studyConfiguration($event,'smeaddprojectexpensesurvey')"
                                                [switchState]="studyConfigurationSettings.checksmeaddprojectexpensesurvey">
                                            </toggle-switch>
                                            Add new Business Components
                                        </div>
                                    </div>
                                </div>
                                <div class="inline-div-second" id="studyDetails" *ngIf="!isClientAdmin">
                                    <div class="col-6 study-head-dir">
                                        <div class="rde-row  ignore-col head-row">
                                            <span>
                                                <h5 class="study-details">General Configurations</h5>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-6 ">
                                        <toggle-switch
                                            (toggleState)="studyConfiguration($event,'isenableagileanalyzer')"
                                            [switchState]="studyConfigurationSettings.isEnableAgileAnalyzer">
                                        </toggle-switch>
                                        Agile Analyzer
                                    </div>
                                </div>
                            </div>


                            <!--End of div-->
                        </div>

                        <form [formGroup]="taxTargetForm">
                            <div class="rde-row" id="taxYear" [ngClass]="{'hidden': !selectedTab.selectTaxYear}">
                                <section class="table-generated-information taxperiod-table taxperiod-sec">
                                    <table class="taxperiod-table">
                                        <thead>
                                            <tr>
                                                <th class="width-30">
                                                    <i class="far fa-asterisk star-style"></i> Tax Period Name
                                                </th>
                                                <th class="width-20">
                                                    <i class="far fa-asterisk star-style"></i> Start Date
                                                </th>
                                                <th class="width-20">
                                                    <i class="far fa-asterisk star-style"></i> End Date
                                                </th>
                                                <th class="width-12">
                                                    Estimated QRE
                                                </th>
                                                <th class="width-10">
                                                    Employee Working Hour Threshold
                                                </th>
                                                <th class="width-10">
                                                    Base Year
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody formArrayName="taxPeriodsFormArray">
                                            <ng-container *ngFor="let row of taxPeriodsFormArray.controls;let i=index"
                                                [formGroupName]="i">
                                                <tr>
                                                    <td class="taxperiodpadding">
                                                        <input id="taxPeriodName" class="black-input opposite-colors"
                                                            maxlength="20" placeholder="Required" type="text"
                                                            no-special-chars="!$%^<>+='"
                                                            (blur)="trimTaxPeriodSpecialChar(i);"
                                                            formControlName="taxPeriodName"
                                                            (input)="trimTaxPeriodSpecialChar(i);taxPeriodNameChange(i)" />
                                                    </td>
                                                    <td class="date-padding">
                                                        <span class="input-group startdate-input duedate-input">
                                                            <input type="text" id="startdate"
                                                                class="date-input date opposite-colors engagement-datepicker"
                                                                [ngClass]="{'ng-invalid-date': row.value.dateError}"
                                                                placeholder="MM/DD/YYYY" [maxDate]="maxDate"
                                                                bsDatepicker
                                                                [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                                                (bsValueChange)="updateStartDate($event, i)"
                                                                (input)="onfocStartDate()" formControlName="startDate"
                                                                no-special-chars="!$%^<>+='" #dpStart="bsDatepicker"
                                                                (focus)="onfocStartDate()" />
                                                            <span class="input-group-append cal-icon">
                                                                <i class="fa fa-calendar-alt create-datepic"
                                                                    (click)="openDatePickerStart()"></i>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td class="date-padding">
                                                        <span class="input-group startdate-input duedate-input">
                                                            <input type="text"
                                                                class="date-input date opposite-colors engagement-datepicker"
                                                                id="enddate{{i}}"
                                                                [ngClass]="{'ng-invalid-date': row.value.dateError}"
                                                                [maxDate]="maxDate" [minDate]="row.value.startDate"
                                                                placeholder="MM/DD/YYYY" bsDatepicker
                                                                [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                                                (bsValueChange)="validateEndDate($event, i)"
                                                                (input)="onfocStartDate()" formControlName="endDate"
                                                                no-special-chars="!$%^<>+='" #dpEnd="bsDatepicker"
                                                                (focus)="onfocEndDate()" style="opacity: 1;">
                                                            <span class="input-group-append cal-icon"
                                                                (click)="openDatePickerStart()">
                                                                <i class="fa fa-calendar-alt create-datepic"
                                                                    (click)="openDatePickerStart()"></i>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td class="taxperiodpadding">
                                                        <input class="black-input opposite-colors"
                                                            (input)="validateTaxPeriod(i)" max=99999999999999.9888
                                                            placeholder="Optional" formControlName="estimatedQRE"
                                                            type="number">
                                                    </td>
                                                    <td class="taxperiodpadding">
                                                        <input class="black-input opposite-colors" min="0" max="8784"
                                                            value="2500" placeholder="Optional"
                                                            formControlName="employeeWorkingHourThreshold" type="number"
                                                            onlyNumber (input)="validateTaxPeriod(i)">
                                                    </td>
                                                    <td class="taxperiodpadding">
                                                        <div [ngClass]="{ 'hidden' : i ===0  }">
                                                            <toggle-switch (toggleState)="baseYearClick($event, i)"
                                                                [switchState]="row.value.baseYear"
                                                                formControlName="baseYear">
                                                            </toggle-switch>
                                                        </div>
                                                    </td>
                                                    <td class="taxperiodpadding">
                                                        <div [ngClass]="{ 'hidden' : i ===0  }">
                                                            <button type='button'
                                                                (click)="onDeleteTaxPeriod(row.value.rowIndex)"
                                                                class="transparent-btn">
                                                                <i class="fas fa-trash"></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="1">
                                                        <div class="date-error-sign" *ngIf="row.value.taxNameError">
                                                            <span>Tax Period Name is already in use.</span>
                                                        </div>
                                                    </td>
                                                    <td colspan="1"
                                                        *ngIf="row.value.dateError && dateErrorMessage === 'Invalid Date Format'">
                                                        <div class="date-error-sign">
                                                            <span>{{dateErrorMessage}}</span>
                                                        </div>
                                                    </td>
                                                    <td colspan="3"
                                                        *ngIf="row.value.dateError && dateErrorMessage === 'Start Date cannot be later than End Date'">
                                                        <div class="date-error-sign">
                                                            <span>{{dateErrorMessage}}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </section>
                                <div class="rde-row  ignore-col head-row taxperiodpadding">
                                    <span>
                                        <button type='button' (click)="onAddTaxPeriod()" class="transparent-btn"
                                            [disabled]="taxPeriodsFormArray.controls.length === 14">
                                            <i class="fas fa-plus"></i> Add Tax Period</button>
                                    </span>

                                </div>
                            </div>
                        </form>

                        <!---Start of Access & Permission-------------------------------------------------------->
                    </div>
                </div>
                <!-- End of existing componenet --!-->

                <div class="just-line"></div>
                <div class="comment-line" *ngIf="selectedTab.selectStudyDetails && roleId !== clientAdmin">
                    <span class="comment-text">Onboard clients to Digital Gateway for enhanced client experience.</span>
                    <span class="comment-link" (click)="onboardClientClick()">Onboard new client<i
                            class="icon fa-solid fa-arrow-up-right-from-square"></i></span>
                </div>

            </div>
            <!-- <right-side-drawer (mandatoryindicator)="confirm($event)"></right-side-drawer> -->
        </form>

    </div>
</div>